(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function initCountdown(section) {
      var endDatetime = section.dataset.endDatetime;
      if (!endDatetime) return;

      var endTime = new Date(endDatetime.replace(' ', 'T')).getTime();
      if (Number.isNaN(endTime)) return;

      var daysEl = section.querySelector('[data-countdown-days]');
      var hoursEl = section.querySelector('[data-countdown-hours]');
      var minutesEl = section.querySelector('[data-countdown-minutes]');
      var secondsEl = section.querySelector('[data-countdown-seconds]');
      var expiredEl = section.querySelector('[data-countdown-expired]');
      var hideWhenExpired = section.dataset.hideWhenExpired === 'true';
      var expiredMessage = section.dataset.expiredMessage;

      function renderRemaining(distance) {
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(seconds);
      }

      function handleExpired() {
        section.classList.add('is-expired');

        if (hideWhenExpired) {
          section.style.display = 'none';
          return;
        }

        if (expiredMessage && expiredEl) {
          expiredEl.textContent = expiredMessage;
          expiredEl.classList.remove('visually-hidden');
        }
      }

      function tick() {
        var distance = endTime - Date.now();

        if (distance <= 0) {
          handleExpired();
          return false;
        }

        renderRemaining(distance);
        return true;
      }

      if (!tick()) return;

      var intervalId = window.setInterval(function () {
        if (!tick()) {
          window.clearInterval(intervalId);
        }
      }, 1000);
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.countdown-timer[data-end-datetime]').forEach(initCountdown);
    });

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.countdown-timer[data-end-datetime]');
      if (section) initCountdown(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const swiperContainer = document.querySelector('[data-swiper-mobile]');
    if (!swiperContainer) return;

    let swiperInstance = null;
    const mobileBreakpoint = 768;

    function initSwiper() {
      if (window.innerWidth <= mobileBreakpoint && !swiperInstance) {
        swiperInstance = new Swiper(swiperContainer, {
          slidesPerView: 1,
          spaceBetween: 20,
          autoHeight: true,
          grabCursor: true,
          autoplay: {
            delay: 3000,
            disableOnInteraction: false,
          },
          loop: true,
        });
      } else if (window.innerWidth > mobileBreakpoint && swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    // Initialize on load
    initSwiper();

    // Reinitialize on resize with debounce
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initSwiper, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const faqToggles = document.querySelectorAll('[data-faq-toggle]');

    faqToggles.forEach((toggle) => {
      toggle.addEventListener('click', function () {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        const answer = this.nextElementSibling;

        // Close all other FAQ items
        faqToggles.forEach((otherToggle) => {
          if (otherToggle !== this) {
            otherToggle.setAttribute('aria-expanded', 'false');
            const otherAnswer = otherToggle.nextElementSibling;
            otherAnswer.classList.remove('active');
            otherAnswer.style.padding = '0 0';
          }
        });

        // Toggle current FAQ item
        if (isExpanded) {
          this.setAttribute('aria-expanded', 'false');
          answer.classList.remove('active');
          answer.style.padding = '0 0';
        } else {
          this.setAttribute('aria-expanded', 'true');
          answer.classList.add('active');
          answer.style.padding = '24px 0';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  // Smart product selector functionality
  function initializeProductSelectors() {
    const selectors = document.querySelectorAll('.comparison-table .product-selector select');

    // Get products from the existing options in the selectors
    const products = [];
    if (selectors.length > 0) {
      const firstSelector = selectors[0];
      for (let i = 0; i < firstSelector.options.length; i++) {
        const option = firstSelector.options[i];
        if (option.value) {
          products.push(option.value);
        }
      }
    }

    // Add change event listeners
    selectors.forEach((selector, selectorIndex) => {
      selector.addEventListener('change', function () {
        const selectedValue = this.value;

        if (selectedValue) {
          // Check if any other selector has the same value
          const otherSelectors = Array.from(selectors).filter((_, index) => index !== selectorIndex);
          const conflictingSelectors = otherSelectors.filter((otherSelector) => otherSelector.value === selectedValue);

          if (conflictingSelectors.length > 0) {
            // Reset conflicting selectors to empty
            conflictingSelectors.forEach((conflictingSelector) => {
              conflictingSelector.value = '';
              updateProductDisplay(conflictingSelector, '');
            });
          }
        }

        // Update the current selector's display
        updateProductDisplay(this, selectedValue);

        // Update all selectors to disable already selected products
        updateSelectorOptions(selectors);
      });
    });

    // Initialize selector options on page load
    updateSelectorOptions(selectors);
  }

  function updateSelectorOptions(selectors) {
    const selectedValues = Array.from(selectors)
      .map((s) => s.value)
      .filter((v) => v);

    selectors.forEach((selector) => {
      const currentValue = selector.value;

      // Update all options
      for (let i = 0; i < selector.options.length; i++) {
        const option = selector.options[i];
        const optionValue = option.value;

        if (optionValue && optionValue !== currentValue) {
          // Disable if already selected in another dropdown
          option.disabled = selectedValues.includes(optionValue);
          option.style.color = option.disabled ? '#999' : '#000';
        } else if (optionValue === currentValue) {
          // Enable current selection
          option.disabled = false;
          option.style.color = '#000';
        }
      }
    });
  }

  function updateProductDisplay(selector, productValue) {
    // Find the parent product container
    const productContainer = selector.closest('.product-container');
    if (productContainer) {
      // Update the product title display
      const productItem = productContainer.querySelector('.product-item span');
      if (productItem) {
        productItem.textContent = productValue || 'Select a product...';
      }

      // If no product selected, show placeholder and clear specifications
      if (!productValue) {
        const productImage = productContainer.querySelector('.product-image img');
        const productPlaceholder = productContainer.querySelector('.product-image .product-placeholder');

        if (productImage) {
          productImage.style.display = 'none';
        }
        if (productPlaceholder) {
          productPlaceholder.querySelector('span').textContent = 'Product Image';
          productPlaceholder.style.display = 'flex';
        }

        // Clear specifications
        clearTableData(productContainer);
        return;
      }

      // Find the corresponding product from the select options to get its image
      const allSelectors = document.querySelectorAll('.comparison-table .product-selector select');
      let selectedProduct = null;

      // Find the product data from any of the selectors
      if (allSelectors.length > 0) {
        const firstSelector = allSelectors[0];
        for (let i = 0; i < firstSelector.options.length; i++) {
          const option = firstSelector.options[i];
          if (option.value === productValue) {
            // Get the product data from the option's data attributes
            selectedProduct = {
              title: option.value,
              image: option.dataset.image || '',
              imageAlt: option.dataset.imageAlt || productValue,
            };
            break;
          }
        }
      }

      // Update the product image
      const productImage = productContainer.querySelector('.product-image img');
      const productPlaceholder = productContainer.querySelector('.product-image .product-placeholder');

      if (selectedProduct && selectedProduct.image) {
        // Show the image
        if (productImage) {
          productImage.src = selectedProduct.image;
          productImage.alt = selectedProduct.imageAlt;
          productImage.style.display = 'block';
        }
        if (productPlaceholder) {
          productPlaceholder.style.display = 'none';
        }
      } else {
        // Show placeholder
        if (productImage) {
          productImage.style.display = 'none';
        }
        if (productPlaceholder) {
          productPlaceholder.querySelector('span').textContent = `${productValue} Image`;
          productPlaceholder.style.display = 'flex';
        }
      }

      // Update the table data for this column
      updateTableData(productContainer, productValue);
    }
  }

  function updateTableData(container, productValue) {
    // Find which column this is (1st, 2nd, or 3rd)
    const allContainers = document.querySelectorAll('.comparison-table .product-container');
    const columnIndex = Array.from(allContainers).indexOf(container);

    if (columnIndex >= 0) {
      // Show loading state
      const allRows = document.querySelectorAll('.comparison-table tr.desktop-only');
      allRows.forEach((row) => {
        const cells = row.querySelectorAll('td.col');
        if (cells[columnIndex]) {
          cells[columnIndex].innerHTML =
            '<span style="color: #007acc; font-style: italic;">⏳ Loading specifications...</span>';
        }
      });

      // Fetch product data via AJAX
      fetchProductSpecifications(productValue, columnIndex);
    }
  }

  function fetchProductSpecifications(productTitle, columnIndex) {
    // Find product by title in the current page data
    const product = findProductByTitle(productTitle);
    if (product) {
      updateSpecificationsFromProduct(product, columnIndex);
    } else {
      showError(columnIndex, 'Product not found in current data');
    }
  }

  function findProductByTitle(productTitle) {
    // Try to find the product in the current page's product data
    const productData = window.productSpecificationsData || {};
    return productData[productTitle] || null;
  }

  function updateSpecificationsFromProduct(product, columnIndex) {
    // Update all table cells in this column with the new product's specifications
    const allRows = document.querySelectorAll('.comparison-table tr.desktop-only');
    const specFields = [
      'headrest',
      'mechanism',
      'mesh_material',
      'waterfall_shapedseat_cushion',
      'lumbar_support',
      'armrests',
      'seat_height',
      'seat_width',
      'seat_depth',
      'overall_height',
      'recline_angle',
      'net_weight',
      'max_recommended_weight',
      'recommended_user_height_range',
    ];

    allRows.forEach((row, rowIndex) => {
      const cells = row.querySelectorAll('td.col');
      if (cells[columnIndex] && rowIndex < specFields.length) {
        const specField = specFields[rowIndex];
        const specValue = getSpecificationValue(product, specField);
        cells[columnIndex].textContent = specValue || '-';
      }
    });
  }

  function getSpecificationValue(product, specField) {
    // Extract specification value from product metafields
    if (product.metafields && product.metafields.custom && product.metafields.custom.product_specifications) {
      const specs = product.metafields.custom.product_specifications;
      return specs[specField] || null;
    }
    return null;
  }

  function clearTableData(container) {
    // Find which column this is (1st, 2nd, or 3rd)
    const allContainers = document.querySelectorAll('.comparison-table .product-container');
    const columnIndex = Array.from(allContainers).indexOf(container);

    if (columnIndex >= 0) {
      // Clear all table cells in this column
      const allRows = document.querySelectorAll('.comparison-table tr.desktop-only');
      allRows.forEach((row) => {
        const cells = row.querySelectorAll('td.col');
        if (cells[columnIndex]) {
          cells[columnIndex].textContent = '-';
        }
      });
    }
  }

  function showError(columnIndex, message) {
    const allRows = document.querySelectorAll('.comparison-table tr.desktop-only');
    allRows.forEach((row) => {
      const cells = row.querySelectorAll('td.col');
      if (cells[columnIndex]) {
        cells[columnIndex].innerHTML = '<span style="color: #dc3545; font-style: italic;">❌ ' + message + '</span>';
      }
    });
  }

  // Alternative approach: Add a refresh button to update the page with new selections
  function addRefreshButton() {
    const tableContainer = document.querySelector('.comparison-table-container');
    if (tableContainer && !document.querySelector('.refresh-specs-btn')) {
      const refreshBtn = document.createElement('button');
      refreshBtn.className = 'refresh-specs-btn';
      refreshBtn.innerHTML = '🔄 Update Specifications';
      refreshBtn.style.cssText = `
        background: #007acc;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 5px;
        cursor: pointer;
        margin: 10px 0;
        font-size: 14px;
        font-weight: 500;
      `;
      refreshBtn.onclick = function () {
        window.location.reload();
      };
      tableContainer.insertBefore(refreshBtn, tableContainer.firstChild);
    }
  }

  function getProductData(productValue) {
    // This function is kept for compatibility but won't be used with dynamic metaobject data
    // In a real implementation, you would fetch this data via AJAX or pass it from Liquid
    return {};
  }

  function setChildWidth() {
    // Only run on mobile (screen width <= 768px)
    if (window.innerWidth > 768) {
      return;
    }

    const table = document.querySelector('.comparison-table');
    const childElements = document.querySelectorAll('.comparison-table .child');

    if (table && childElements.length > 0) {
      const viewportWidth = window.innerWidth;

      childElements.forEach((child) => {
        child.style.width = viewportWidth + 'px';
      });
    }
  }

  function applyAlternatingColors() {
    // Only apply alternating colors on desktop (width > 768px)
    if (window.innerWidth <= 768) {
      return;
    }

    const rows = document.querySelectorAll('.comparison-table tr');
    let visibleRowIndex = 0;

    rows.forEach((row, index) => {
      // Skip the header row (index 0)
      if (index === 0) return;

      // Only apply to desktop-only rows
      if (!row.classList.contains('desktop-only')) return;

      // Apply alternating colors to desktop rows
      if (visibleRowIndex % 2 === 0) {
        // Even visible rows
        row.style.backgroundColor = '#1A1A1A';
      } else {
        // Odd visible rows
        row.style.backgroundColor = '#000000';
      }

      visibleRowIndex++;
    });
  }

  // Set width on page load
  window.addEventListener('load', setChildWidth);

  // Set width on window resize
  window.addEventListener('resize', setChildWidth);

  // Reapply colors on window resize
  window.addEventListener('resize', applyAlternatingColors);

  // Set width when DOM is ready
  document.addEventListener('DOMContentLoaded', setChildWidth);

  // Initialize product selectors when DOM is ready
  document.addEventListener('DOMContentLoaded', initializeProductSelectors);

  // Apply alternating colors on page load
  window.addEventListener('load', applyAlternatingColors);

  // Apply alternating colors when DOM is ready
  document.addEventListener('DOMContentLoaded', applyAlternatingColors);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-navigation-tabs"] && !Shopify.designMode) return;
  try {
    
  class ProductNavigationTabs {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.navLinks = document.querySelectorAll(`#${sectionId} .nav-tab-link`);
      this.sections = [];
      this.currentActive = null;
      this.currentTabIndex = 0;

      this.init();
    }

    init() {
      this.findSections();
      console.log('Found sections:', this.sections); // Debug log
      this.setupTabSwitching();
      this.setActiveTab(this.navLinks[0], 0); // Set first tab as active by default

      // Try to show first tab content
      if (this.sections.length > 0) {
        this.showTab(0); // Show first tab content
      } else {
        console.log('No sections found, trying to find sections again...');
        // Wait a bit and try again in case sections load after
        setTimeout(() => {
          this.findSections();
          if (this.sections.length > 0) {
            this.showTab(0);
          }
        }, 100);
      }
    }

    findSections() {
      // Find sections that correspond to nav tabs
      this.navLinks.forEach((link) => {
        const sectionId = link.getAttribute('data-section');

        // Try to find section by exact ID first
        let section = document.getElementById(sectionId);

        // If not found, try to find by partial ID match
        if (!section) {
          const allSections = document.querySelectorAll('section[id*="' + sectionId + '"]');
          if (allSections.length > 0) {
            section = allSections[0];
          }
        }

        // If still not found, try to find by class name
        if (!section) {
          const classSections = document.querySelectorAll('section.' + sectionId);
          if (classSections.length > 0) {
            section = classSections[0];
          }
        }

        // If still not found, try to find by section type
        if (!section) {
          const typeSections = document.querySelectorAll('section[class*="' + sectionId + '"]');
          if (typeSections.length > 0) {
            section = typeSections[0];
          }
        }

        if (section) {
          this.sections.push({
            id: sectionId,
            element: section,
            link: link,
          });
          console.log('Found section:', sectionId, section); // Debug log
        } else {
          console.log('Section not found for:', sectionId); // Debug log
        }
      });
    }

    setActiveTab(activeLink, tabIndex) {
      // Remove active class from all links
      this.navLinks.forEach((link) => link.classList.remove('active'));

      // Add active class to current link
      activeLink.classList.add('active');
      this.currentActive = activeLink;
      this.currentTabIndex = tabIndex;
    }

    showTab(tabIndex) {
      console.log('Showing tab:', tabIndex, 'Sections:', this.sections); // Debug log

      if (this.sections.length === 0) {
        console.log('No sections found, cannot show tab content');
        return;
      }

      // Hide all sections
      this.sections.forEach((section, index) => {
        if (section.element) {
          if (index === tabIndex) {
            section.element.style.display = 'block';
            section.element.classList.add('active-tab-content');
            console.log('Showing section:', section.id); // Debug log
          } else {
            section.element.style.display = 'none';
            section.element.classList.remove('active-tab-content');
            console.log('Hiding section:', section.id); // Debug log
          }
        }
      });
    }

    setupTabSwitching() {
      this.navLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          const tabIndex = parseInt(link.getAttribute('data-tab-index'));

          // Set this tab as active
          this.setActiveTab(link, tabIndex);

          // Show the corresponding tab content
          this.showTab(tabIndex);

          // Scroll to the navigation section
          this.scrollToNavigation();
        });
      });
    }

    scrollToNavigation() {
      // Get the sticky navigation handler to access the original position
      const stickyHandler = window.stickyNavigation;

      if (stickyHandler && stickyHandler.offsetTop) {
        // Use the stored original position from the sticky handler
        const navPosition = stickyHandler.offsetTop;
        const offset = 10;

        window.scrollTo({
          top: navPosition - offset,
          behavior: 'smooth',
        });
      } else {
        // Fallback: try to get the navigation section position
        const navSection = document.querySelector('.product-nav-tabs');
        if (navSection) {
          // Temporarily remove sticky class to get original position
          const wasSticky = navSection.classList.contains('is-sticky');
          if (wasSticky) {
            navSection.classList.remove('is-sticky');
          }

          const navPosition = navSection.offsetTop;

          // Restore sticky class if it was there
          if (wasSticky) {
            navSection.classList.add('is-sticky');
          }

          const offset = 10;
          window.scrollTo({
            top: navPosition - offset,
            behavior: 'smooth',
          });
        }
      }
    }

    // Method to refresh sections (useful if sections are added dynamically)
    refreshSections() {
      this.sections = [];
      this.findSections();
      if (this.sections.length > 0) {
        this.showTab(this.currentTabIndex);
      }
    }
  }

  // Sticky Navigation Handler
  class StickyNavigation {
    constructor() {
      this.navSection = document.querySelector('.product-nav-tabs');
      this.placeholder = null;
      this.navHeight = 0;
      this.offsetTop = 0;
      this.isSticky = false;

      if (this.navSection) {
        this.init();
      }
    }

    init() {
      // Create placeholder element
      this.placeholder = document.createElement('div');
      this.placeholder.className = 'nav-tabs-placeholder';
      this.navSection.parentNode.insertBefore(this.placeholder, this.navSection.nextSibling);

      // Get initial measurements
      this.updateMeasurements();

      // Set up scroll listener
      this.setupScrollListener();

      // Handle window resize
      window.addEventListener('resize', () => {
        this.updateMeasurements();
        this.handleScroll();
      });
    }

    updateMeasurements() {
      if (this.navSection) {
        this.navHeight = this.navSection.offsetHeight;
        this.offsetTop = this.navSection.offsetTop;
      }
    }

    setupScrollListener() {
      let ticking = false;

      const handleScroll = () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            this.handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll);
      document.addEventListener('scroll', handleScroll);
    }

    handleScroll() {
      if (!this.navSection) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const shouldBeSticky = scrollTop >= this.offsetTop;

      if (shouldBeSticky && !this.isSticky) {
        this.makeSticky();
      } else if (!shouldBeSticky && this.isSticky) {
        this.makeUnsticky();
      }
    }

    makeSticky() {
      if (!this.navSection || this.isSticky) return;

      this.isSticky = true;
      this.navSection.classList.add('is-sticky');
      this.placeholder.style.height = this.navHeight + 'px';

      // Update z-index to ensure it's above other content
      this.navSection.style.zIndex = '1000';
    }

    makeUnsticky() {
      if (!this.navSection || !this.isSticky) return;

      this.isSticky = false;
      this.navSection.classList.remove('is-sticky');
      this.placeholder.style.height = '0px';

      // Reset z-index
      this.navSection.style.zIndex = '100';
    }

    // Method to refresh measurements (useful after dynamic content changes)
    refresh() {
      this.updateMeasurements();
      this.handleScroll();
    }
  }

  // Initialize navigation tabs when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    const navTabSections = document.querySelectorAll('.product-nav-tabs');
    navTabSections.forEach((section) => {
      new ProductNavigationTabs(section.id);
    });

    // Initialize sticky navigation and store globally
    window.stickyNavigation = new StickyNavigation();
  });

  // Also try to initialize when window loads (in case sections load after DOM)
  window.addEventListener('load', () => {
    const navTabSections = document.querySelectorAll('.product-nav-tabs');
    navTabSections.forEach((section) => {
      if (!section.hasAttribute('data-initialized')) {
        section.setAttribute('data-initialized', 'true');
        new ProductNavigationTabs(section.id);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
